import { render } from "./ModalNuevoTicket.vue?vue&type=template&id=265ca086&scoped=true"
import script from "./ModalNuevoTicket.vue?vue&type=script&lang=js"
export * from "./ModalNuevoTicket.vue?vue&type=script&lang=js"

import "./ModalNuevoTicket.vue?vue&type=style&index=0&id=265ca086&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265ca086"]])

export default __exports__